var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time flex"},[_c('span',[_vm._v("北斗标准时间：")]),_c('span',{staticStyle:{"letter-spacing":"1px"}},[_vm._v(_vm._s(_vm.bdTime.data)+" "+_vm._s(_vm.bdTime.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }